module.exports = {
    PENSION_PLAN_STANDARD: '1',
    PENSION_PLAN_PRODUCT_TYPE: '305',
    PENSION_PLAN_CONTRIBUTION_PRODUCT_TYPE: '306',
    PENSION_PLAN_PRODUCT_SUB_TYPE: '00',
    PENSION_PLAN_TRANSFER_SUB_TYPE: '01',
};
